import { AxiosRequestConfig } from 'axios';
import { EntityFieldsMetadatParams, GetEntityByFieldQueryProps } from './crm-entity.types';
import { CrmDataTypes, ConditionOperator } from 'common/enums';

class CrmEntityRequestConfig {
  getEntityByFieldQuery = (data: GetEntityByFieldQueryProps): AxiosRequestConfig => ({
    method: 'post',
    url: 'crmEntity/getEntityByFieldQuery',
    data
  });

  getLocationsByCompany = (companyId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'crmEntity/getEntityByFieldQuery',
    data: {
      entityName: 'new_standort',
      columns: ['new_name', 'new_standortid'],
      conditions: [
        {
          attributeTypeCode: CrmDataTypes.Lookup,
          attributeName: 'new_firma',
          conditionOperator: ConditionOperator.Equal,
          value: [{ id: companyId }]
        },
        {
          attributeTypeCode: CrmDataTypes.State,
          attributeName: 'statecode',
          conditionOperator: ConditionOperator.Equal,
          value: [{ value: '0' }]
        }
      ],
      order: { fieldName: 'new_name', reverse: false }
    }
  });

  getEntityFieldsMetadata = (data: EntityFieldsMetadatParams): AxiosRequestConfig => ({
    method: 'post',
    url: 'CrmEntity/GetEntityFieldsMetadata',
    data
  });
}

export const crmEntityRequestConfig = new CrmEntityRequestConfig();
